import { useState } from "react";
import Page, { PageHero } from "../components/Page";
import SubNav from "../components/SubNav";
import { faqs } from "../data/faqs";
import { IconPlus } from "../components/icons";
import styles from "./Faq.module.css";

const aboutSubNav = [
  { label: "About", path: "/about", end: true },
  { label: "Venue Info", path: "/about/venue" },
  { label: "FAQ", path: "/about/faq" },
  { label: "SFMA", path: "/about/sfma" },
  { label: "Press", path: "/about/press" },
  { label: "Contact", path: "/about/contact" },
];

function Item({ q, a }) {
  const [open, setOpen] = useState(false);
  return (
    <li className={[styles.item, open ? styles.open : ""].join(" ")}>
      <button
        type="button"
        className={styles.q}
        onClick={() => setOpen(!open)}
        aria-expanded={open}
      >
        <span>{q}</span>
        <IconPlus className={styles.plus} />
      </button>
      {open && <div className={styles.a}>{a}</div>}
    </li>
  );
}

export default function Faq() {
  return (
    <>
      <PageHero
        eyebrow="The questions, answered"
        title="FAQ"
        lede="Camping, tickets, dogs, ice, water, fires, bikes, and river access."
        image="/photos/volunteers.jpg"
      />
      <SubNav items={aboutSubNav} />
      <Page narrow>
        {faqs.map((group) => (
          <section key={group.group} className={styles.group}>
            <h2 className={styles.groupTitle}>{group.group}</h2>
            <ul className={styles.list}>
              {group.items.map((it) => (
                <Item key={it.q} q={it.q} a={it.a} />
              ))}
            </ul>
          </section>
        ))}
      </Page>
    </>
  );
}
